import dayjs from 'dayjs';
import { getApi, postApi } from '../../utils/api';

export interface IUserNextAvailableAppointment {
  userId: number;
  nextAvailableAppointmentId: number;
  nextAvailableAppointmentSet: boolean;
}

export interface IUserNextAvailableAppointmentPost {
  date: string;
  nextAvailableAppointmentId: number;
}

export const getUserNextAvailableAppointment = (date: Date) =>
  getApi<IUserNextAvailableAppointment>(
    `appointments/nextavailable/?date=${dayjs(date).format('YYYY-MM-DD')}`
  );

export const postUserNextAvailableAppointment = (
  date: Date,
  nextAvailableAppointmentId: number
) =>
  postApi<IUserNextAvailableAppointment, IUserNextAvailableAppointmentPost>(
    'appointments/nextavailable',
    {
      date: dayjs(date).format('YYYY-MM-DD'),
      nextAvailableAppointmentId,
    }
  );
